import React, { useMemo, useState } from 'react'
import { Pagination, Table } from 'antd'
import moment from 'moment'
import {
  BONUS_POINT_ACTION, POINT_CHANGE_TRANSACTION_TYPES,
} from '../../constants/constant'
import { useIsCompact } from '../../hook/useMediaQuery'
import { MobileCardList } from '../../components/common/MobileCard'
import PointHistoryCard, {
  pointHistoryPointText,
  pointHistoryDetailText,
  pointHistoryAmountText,
  pointHistoryStatusTag,
} from '../../components/manageBonusPoint/PointHistoryCard'
import { POINT_HISTORY_COLUMN_LABEL, POINT_HISTORY_LIST_ARIA_LABEL } from '../../constants/bonusPointLabels'

const POINT_HISTORY_PAGE_SIZE = 10

function BonusPointHistory({
  data, setData = () => {}, setQueryParams, loadingHistory, page, totalCount,
}) {
  const [activeTab, setActiveTab] = useState('point-change')

  // Điện thoại/iPad (≤1199px): thẻ thay bảng (Figma FR-W-10 responsive). Desktop giữ nguyên bảng.
  const isCompact = useIsCompact()
  const showAmount = activeTab === 'point-convert'

  const paginationConfig = useMemo(
    () => ({
      defaultPageSize: 10, // Set initial page size
      onChange: (pageNumber, pageSize) => {
        setQueryParams((prev) => ({
          ...prev,
          page: pageNumber,
        }))
      },
      showSizeChanger: false,
      total: totalCount,
      current: parseInt(page, 10),
    }),
    [totalCount, page],
  )

  const handleChangeTab = (tab) => {
    setData([])
    setActiveTab(tab)
    if (tab === 'point-change') {
      setQueryParams((prev) => ({
        ...prev,
        page: 1,
        limit: 10,
        transaction_types: POINT_CHANGE_TRANSACTION_TYPES,
      }))
    } else {
      setQueryParams((prev) => ({
        ...prev,
        page: 1,
        limit: 10,
        transaction_types: ['withdraw_point'],
      }))
    }
  }

  const columns = [
    {
      title: POINT_HISTORY_COLUMN_LABEL.time,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at) => (
        moment(created_at).format('DD/MM/YYYY')
      ),
    },
    {
      title: POINT_HISTORY_COLUMN_LABEL.type,
      dataIndex: 'transaction_type',
      key: 'transaction_type',
      render: (transaction_type) => (
        BONUS_POINT_ACTION?.[transaction_type]?.name
      ),
    },
    {
      title: POINT_HISTORY_COLUMN_LABEL.detail,
      dataIndex: 'note',
      key: 'note',
      render: (note, record) => pointHistoryDetailText(record),
    },
    {
      title: POINT_HISTORY_COLUMN_LABEL.point,
      dataIndex: 'point',
      key: 'point',
      align: 'right',
      render: (point, record) => {
        const { className, text } = pointHistoryPointText(record)
        return <div className={className}>{text}</div>
      },
    },
    {
      title: POINT_HISTORY_COLUMN_LABEL.amount,
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (amount, record) => pointHistoryAmountText(record),
    },
    {
      title: POINT_HISTORY_COLUMN_LABEL.status,
      dataIndex: 'transaction_status',
      key: 'transaction_status',
      align: 'center',
      render: (item) => pointHistoryStatusTag(item),
    },
  ]

  return (
    <div className="point-history">
      <div className="point-history-action">
        <div className="point-history-item-wrapper">
          <button type="button" className={`point-history-action-item ${activeTab === 'point-change' ? 'active' : ''}`} onClick={() => handleChangeTab('point-change')}>Biến động điểm</button>
          <button type="button" className={`point-history-action-item ${activeTab === 'point-convert' ? 'active' : ''}`} onClick={() => handleChangeTab('point-convert')}>Đổi điểm</button>
        </div>
      </div>
      {isCompact ? (
        <>
          <MobileCardList
            className="point-history-cards"
            ariaLabel={POINT_HISTORY_LIST_ARIA_LABEL}
            items={data}
            itemKey={(item) => item.id}
            loading={loadingHistory}
            renderItem={(item) => <PointHistoryCard item={item} showAmount={showAmount} />}
          />
          <div className="point-history-pagination">
            <Pagination
              current={parseInt(page, 10)}
              total={totalCount}
              pageSize={POINT_HISTORY_PAGE_SIZE}
              showSizeChanger={false}
              size="small"
              onChange={paginationConfig.onChange}
            />
          </div>
        </>
      ) : (
        <Table
          // columns={activeTab === 'point-convert' ? columns : columns.filter((item) => (item.key !== 'transaction_status' && item.key !== 'amount'))}
          columns={activeTab === 'point-convert' ? columns : columns.filter((item) => (item.key !== 'amount'))}
          dataSource={data}
          loading={loadingHistory}
          pagination={paginationConfig}
        />
      )}
    </div>
  )
}

export default BonusPointHistory
